






































































































































/** @format */

import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import PlateInputGroup from '@/components/plate-input-group/index.vue';
import { debounce } from 'lodash';
// @ts-ignore hack
import { trim, phone } from '@root/utils/validators';
// @ts-ignore hack
import { lock, getEnterOrder } from '@/api/lock-car-management/index';

export interface IForm {
  parkId: string; // 父机构id
  plateSearch: string; // 车牌号字符串，接口中需要使用拆分值
  phoneNumber: string; // 手机号
  carOwnerName: string; // 车主姓名
  enterOrderIndex: string; // 在场车辆订单选中序号，接口中依据此值获取具体车牌号和订单id
}

@Component({
  components: {
    ParkingLotSearch,
    PlateInputGroup
  }
})
export default class LockModal extends Vue {
  @Getter('organizations/userParkingIot')
  parkingIotTreeList!: any[];

  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  debounceGetEnterCarList: any = null;
  enterCarListFetching: boolean = false;
  // 在场车辆列表
  enterCarList: any[] = [];
  form: any = null;
  plateArray: string[] = ['', ''];
  // 校验字段方法
  validatorsTrim = trim;
  validatorsPhone = phone;

  confirmLoading: boolean = false;
  labelCol = { span: 6 };
  wrapperCol = { span: 15 };
  wrapperColLine = { span: 24 };

  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }

  mounted() {
    this.debounceGetEnterCarList = debounce(this.getEnterCarList, 800);
    this.init();
  }

  init() {
    this.form = this.$form.createForm(this);
    // 判断单车场，自动填入车场id
    const parkLotList = this.parkingIotTreeList.filter(item => item.type === 'park');
    if (parkLotList && parkLotList.length == 1) {
      this.form.setFieldsValue({ parkId: parkLotList[0].id });
    }
  }

  plateSearchChange(value: any, array: string[]) {
    if (this.visible) {
      this.plateArray = array;
      this.enterCarList = [];
      this.debounceGetEnterCarList();
    }
  }
  parkIdChange() {
    if (this.visible) {
      this.enterCarList = [];
      this.debounceGetEnterCarList();
    }
  }

  // 获取在场车辆列表
  async getEnterCarList() {
    const parkId = this.form.getFieldsValue().parkId;
    if (!parkId) {
      return false;
    } else if (this.plateArray.join('').length < 3) {
      return false;
    } else {
      if (this.enterCarListFetching) return false;
      this.enterCarListFetching = true;
      try {
        const { data = {} } = await getEnterOrder({
          parkId,
          plateHead: this.plateArray[0],
          plateTail: this.plateArray[1],
          currPage: 1,
          pageSize: 20
        });
        this.enterCarList = data.datas || [];
      } catch (e) {
        this.enterCarList = [];
        this.$message.error((e && e.msg) || '查询在场车辆失败');
      } finally {
        this.enterCarListFetching = false;
      }
    }
  }

  // 提交锁车
  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        if (this.confirmLoading) return false;
        this.confirmLoading = true;
        try {
          const { parkId, phoneNumber, carOwnerName, enterOrderIndex } = values;
          const result = await lock({
            parkId,
            phoneNumber,
            carOwnerName,
            // @ts-ignore hack
            plate: this.enterCarList[enterOrderIndex].plate || '',
            // @ts-ignore hack
            orderId: this.enterCarList[enterOrderIndex].pkOrderId || ''
          });
          this.$message.success('锁车成功');
          this.form.resetFields();
          this.$emit('ok');
        } catch (e) {
          this.$message.error((e && e.msg) || '锁车失败');
        } finally {
          this.confirmLoading = false;
        }
      }
    });
  }
}
